import { render, staticRenderFns } from "./CurtainTab.vue?vue&type=template&id=4ee25a87"
import script from "./CurtainTab.vue?vue&type=script&lang=js"
export * from "./CurtainTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports